import { resolveIdentifier, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { Pharmacy } from './Pharmacy';

export const PharmacyAnnualReview = types.compose(
  BaseEntity,
  types
    .model('PharmacyAnnualReview', {
      pharmacyAnnualReviewId: types.identifierNumber,
      pharmacyId: types.integer,
      year: types.integer,
      actualDutyCount: types.maybe(types.integer),
      averageDutyCount: types.maybe(types.integer),
      approvedBalance: types.maybe(types.integer),
      prevActualDayDutyCount: types.maybe(types.number),
      actualDayDutyCount: types.maybe(types.integer),
      averageDayDutyCount: types.maybe(types.integer),
      approvedDayBalance: types.maybe(types.integer),
      prevActualNightDutyCount: types.maybe(types.number),
      actualNightDutyCount: types.maybe(types.integer),
      averageNightDutyCount: types.maybe(types.integer),
      approvedNightBalance: types.maybe(types.integer),
      status: types.maybe(types.string),
    })
    .views((self) => {
      return {
        get pharmacy() {
          if (self.pharmacyId) {
            return resolveIdentifier(Pharmacy, self, self.pharmacyId);
          } else {
            return null;
          }
        },
      };
    }),
);
